<template>
    <v-container fluid class="no-padding">
        <!-- <div class="prodocs-wrap">
            <v-row>
                <v-col cols="12" md="12">
                    <v-img style="margin:auto;" :src="require('@/assets/logoadq.png')" max-width="50%" contain/> 
                    <h2 class="section-title">Implementing Partner Dashboard</h2>
                    <v-divider class="section-divider"></v-divider>
                    <Perfil />
                </v-col>
            </v-row>
        </div>-->
        <Perfil />
    </v-container>
</template>

<script>
import Perfil from './Perfil/Perfil.vue';

export default {
    name: 'Begin',
    components: {
        Perfil
    },
    data() {
        return {
            dato: {
                oid: 0,
                cargo: '',
                desc_cargo: '',
                fecha_cierre: null,
                fecha_creacion: null,
                obs: '',
                activo: 0,
            },
        }
    },
    computed: {

    },
    methods: {
        
    },
    mounted() {
    },
}
</script>
<style scoped>
    p {
      font-family: 'Heebo', sans-serif !important;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
      font-family: 'Heebo', sans-serif !important;
        font-size: 2.5rem;
    }
    h2 {
      font-family: 'Heebo', sans-serif !important;
        font-size: 2.5rem;
    }
    h3 {
      font-family: 'Heebo', sans-serif !important;
    }
    h5 {
        font-family: 'Heebo', sans-serif !important;
        font-size: 1.25rem;
    }
    .section-title{
        color: rgb(0,30,67);
        font-size: 40px;
        margin: 12px 0 6px;
    }
    .section-text{
        color: rgb(0,30,67);
        margin-top: 8px;
    }
    .section-divider{
        border-bottom: #29ABE2 solid 3px;
    }
</style>
